import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'

import style from './style'

import { TextField, Box, Grid, Button } from '@material-ui/core'
import { useParams, useHistory } from 'react-router-dom'
import axios from '../../Services/axios'
import Swal from 'sweetalert2'
import LocalStorage from '../../Services/LocalStorage'

export default function CadastrarFeedback(){

    const { notificacao_id } = useParams()
    const history = useHistory()

    const conselheiro = JSON.parse(LocalStorage.get("usuario"))

    const classes = style()
    const [dados, setDados] = useState({
        descricao: '',
        notificacao_id: parseInt(notificacao_id),
        conselheiro_id: conselheiro.id,
    })

    const validations = {
        descricao: 'string|required',
        conselheiro_id: 'required|number',
        notificacao_id: 'required|number'
    }
    
    const INITIAL_ERRORS = {
        descricao: false,
        notificacao_id: false,
        conselheiro_id: false
    }
    const [errors, setErrors] = useState(INITIAL_ERRORS)

    const save = () => {
        validate(dados)

        axios
            .post(`feedback`, dados)
            .then(() => {
                Swal.fire("Registro salvo com sucesso.")
                history.push("/feedback")
            })
            .catch(() => {
                Swal.fire("Falha ao salvar registro, tente novamente.")
            })
    }

    const validate = (dados) => {

        let localErrors = INITIAL_ERRORS

        const keys = Object.keys(validations)

        keys.forEach(key => {
            const constraints = validations[key].split('|')
            constraints.forEach(constraint => {
                const dado = dados[key]
                switch(constraint){
                    case 'string':
                        if(typeof dado !== 'string'){
                            localErrors[key] = key
                        }
                    break;

                    case 'number':
                        if(typeof dado !== 'number'){
                            localErrors[key] = key
                        }
                    break;
                    
                    case 'required':
                        if(dado === '' || dado === 0){
                            localErrors[key] = key
                        }
                    break;

                    default:
                        break;
                }
            })
        })

        setErrors({
            ...localErrors
        })
    }

    const keys = Object.keys(errors)

    return (
        <div>
            <Typography className={classes.title} variant="h1" >Cadastro de Feedbacks</Typography>

            {
                keys.map(err => {
                    if(errors[err]){
                        return (
                            <Typography key={err} color="error">* Verifique o campo {errors[err]}</Typography>
                        )
                    }
                    return null
                })
            }

            <form>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Box component="div" m={4}>
                            <TextField variant="outlined" multiline={true} rows={10} label="Conteúdo" size="small" fullWidth error={errors.descricao ? true : false} value={dados.descricao} onChange={(event) => {
                                setDados({
                                    ...dados,
                                    descricao: event.target.value
                                })
                            }} />
                        </Box>
                    </Grid>
                </Grid>

                <Grid container spacing={1} justify="flex-end">
                    <Grid item sx={12}>
                        <Button variant="contained" color="primary" onClick={() => save()}>
                          Salvar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}